import {DokumentPogodbaEnum} from '../Enum/Narocilnica/DokumentPogodbaEnum'

export default class OrderDocument {
  /**
   * @type {number | null}
   * @private
   */
  _id = null
  /**
   * @type {string | null}
   * @private
   */
  _title = null
  /**
   * @type {string | null}
   * @private
   */
  _value = null
  /**
   * @type {array | null}
   * @private
   */
  _checkBoxes = null

  static createFromResponseItem (doc) {
    let out = new this()
    out._id = doc.id
    out._title = doc.title
    out._value = doc.value
    out._checkBoxes = []
    if (doc.id === DokumentPogodbaEnum.PANDA_POSLOVNA_LICENCNA_POGODBA) {
      out._checkBoxes.push({
        value: false,
        text: 'Izjavljam, da sem prebral/-a in se strinjam z licenčno pogodbo.'
      })
    }
    return out
  }

  getContentForEmbedded (prefixBase64 = true) {
    return (prefixBase64 === true ? 'data:application/pdf;base64,' : '') + this._value
  }

  get id () {
    return this._id
  }

  set id (value) {
    this._id = value
  }

  get title () {
    return this._title
  }

  set title (value) {
    this._title = value
  }

  get value () {
    return this._value
  }

  set value (value) {
    this._value = value
  }

  get checkBoxes () {
    return this._checkBoxes
  }

  set checkBoxes (value) {
    this._checkBoxes = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Order/OrderDocument.js